export function quarter(date) {
  return 1 + ~~(new Date(date).getMonth() / 3);
}

export function utcquarter(date) {
  return 1 + ~~(new Date(date).getUTCMonth() / 3);
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/expression/quarter.js
// module id = 1428
// module chunks = 0